import comp from "./AiQuestionAssistant";
export default comp;
